import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearAttribution } from '../utils/attribution';

const AuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    console.log('AuthCallbackPage: Component mounted');
    console.log('AuthCallbackPage: Current pathname:', location.pathname);
    console.log('AuthCallbackPage: Current search:', location.search);
    console.log('AuthCallbackPage: Full URL:', window.location.href);
    
    const processAuth = async () => {
      try {
        console.log('AuthCallbackPage: Processing authentication callback');
        
        // Get token from URL query parameters
        const params = new URLSearchParams(location.search);
        console.log('AuthCallbackPage: All URL parameters:', Object.fromEntries(params.entries()));
        
        const token = params.get('token');
        const refreshToken = params.get('refresh_token');

        if (token) {
          console.log('AuthCallbackPage: Token found in URL:', token.substring(0, 20) + '...');

          // Store access token
          localStorage.setItem('token', token);
          console.log('AuthCallbackPage: Access token stored in localStorage');

          // Store refresh token if present
          if (refreshToken) {
            localStorage.setItem('refresh_token', refreshToken);
            console.log('AuthCallbackPage: Refresh token stored in localStorage');
          }

          // Clear stored attribution after successful OAuth authentication
          clearAttribution();

          console.log('AuthCallbackPage: Redirecting to /reports');

          // Use window.location.href for a full page reload instead of navigate
          window.location.href = '/reports';
          return;
        } else {
          console.log('AuthCallbackPage: No token found in URL');
        }
        
        // If this is a direct OAuth callback with code and state
        if (location.pathname.includes('/login/') && location.pathname.includes('/authorized')) {
          console.log('OAuth callback detected, handling directly');
          
          // Extract the provider from the URL
          const provider = location.pathname.includes('google') ? 'google' : 
                          location.pathname.includes('yandex') ? 'yandex' : 'unknown';
          
          // Construct the backend callback URL using relative URL
          // Use the same path that's registered in Google Developer Console
          const backendCallbackUrl = `/api/v1/auth/login/${provider}/authorized${location.search}`;
          console.log('Redirecting to backend callback URL:', backendCallbackUrl);
          
          // Redirect to the backend callback URL
          window.location.href = backendCallbackUrl;
          return;
        }
        
        // If we got here, we don't have a token and it's not an OAuth callback
        setError('No authentication token received');
        setLoading(false);
      } catch (err) {
        console.error('Error processing authentication callback:', err);
        setError('Failed to process authentication');
        setLoading(false);
      }
    };
    
    processAuth();
  }, [location, navigate]);
  
  if (loading) {
    return (
      <div className="auth-callback-page">
        <div className="loading-container">
          <h2>Completing authentication...</h2>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="auth-callback-page">
        <div className="error-container">
          <h2>Authentication Error</h2>
          <p className="error-message">{error}</p>
          <button 
            className="retry-button"
            onClick={() => navigate('/login')}
          >
            Return to Login
          </button>
        </div>
      </div>
    );
  }
  
  return null;
};

export default AuthCallbackPage;
